import styled from 'styled-components';
import ButtonForInstructor from '../ButtonForInstructor';

const ButtonForStudent = styled(ButtonForInstructor)`
  color: #2cc4eb;
  border-color: #2cc4eb;
`;

export default ButtonForStudent;
